import React from 'react';
import ResponsiveTabMenu from '@shared/components/ResponsiveTabMenu';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatUrlTemplate } from '../../../utils/stringExtensions';

/**
 * @typedef {object} ResponsiveUrlTabMenuTabs
 * @property {string} [value]
 * @property {string} [displayName]
 * @property {string} [urlTemplate]
 */

/**
 * @typedef {object} ResponsiveUrlTabMenuProps
 * @property {ResponsiveUrlTabMenuTabs[]} tabs
 * @property {Object} [urlParams]
 * @property {boolean} [loading]
 */

/**
 * @param {ResponsiveUrlTabMenuProps} props
 */
const ResponsiveUrlTabMenu = props => {
  const { tabs, urlParams = {}, loading = false } = props;

  const { pathname, state } = useLocation();
  const navigate = useNavigate();

  const activeTab = tabs.find(tab => pathname.includes(tab.value));

  const handleTabChange = targetTabValue => {
    const targetTab = tabs.find(tab => tab.value === targetTabValue);
    const url = formatUrlTemplate(targetTab.urlTemplate, urlParams);
    navigate(url, { state });
  };

  return (
    <ResponsiveTabMenu
      loading={loading}
      activeTab={activeTab.value}
      tabs={tabs}
      onChange={handleTabChange}
    />
  );
};

export default ResponsiveUrlTabMenu;
